<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="50" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="设计者">
          <ThrottleSelector
            v-model="designerId"
            :list="operatorData"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>

        <ElFormItem label="项目组">
          <ThrottleSelector
            v-model="projectGroupId"
            :list="projectGroupData"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>

        <ElFormItem label-width="44" label="月份">
          <ElDatePicker
            v-model="datemonth"
            value-format="yyyy-MM"
            :options="datetimeOption"
            type="month"
            placeholder="全部"
            style="width: 120px"
          />
        </ElFormItem>

        <ElFormItem label-width="0" class="bg-transparent">
          <div class="operate-btns">
            <ElButton type="primary" @click="$emit('on-add')">新增设计KPI</ElButton>
            <ElButton @click="$emit('on-down')">模版下载</ElButton>
            <Upload action="" :before-upload="preUpload" accept="application/vnd.ms-excel,.xls,.xlsx,.csv">
              <ElButton style="margin-left: 10px">导入设计KPI</ElButton>
            </Upload>
          </div>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import ThrottleSelector from '@/components/throttle-select/index.vue'

export default {
  name: 'TagsFilter',
  components: { ThrottleSelector },
  props: {
    operatorData: {
      type: Array
    },
    projectGroupData: {
      type: Array
    }
  },
  data() {
    return {
      designerId: '',
      projectGroupId: '',
      datemonth: '',
      datetimeOption: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      }
    }
  },
  methods: {
    sendEvent() {
      this.$emit('on-change', {
        month: this.datemonth || undefined,
        projectGroupId: this.projectGroupId === '' ? undefined : this.projectGroupId,
        designerId: this.designerId === '' ? undefined : this.designerId
      })
    },
    preUpload(file) {
      this.emitImport(file)
      return false
    },
    emitImport(file) {
      this.$emit('on-import', file)
    }
  },
  watch: {
    datemonth() {
      this.sendEvent()
    }
  }
}
</script>
<style lang="scss" scoped>
@import './styles/table-filters.scss';
</style>
